"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinPlaceholder = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireDefault(require("react"));
require("./SpinPlaceholder.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Block-level spin element for when a spinner is used as a placeholder for the loading content.
 * This component is meant to completely replace the content, vs.
 * Antd <Spin> which wraps the content in a white overlay.
 */
var SpinPlaceholder = function SpinPlaceholder(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "spin-placeholder"
  }, /*#__PURE__*/_react.default.createElement(_spin.default, props));
};
exports.SpinPlaceholder = SpinPlaceholder;